export default function EurailCardsService($uibModalStack) {
    'ngInject';

    Object.assign(this, {
        addCardToPassenger,
        saveCard,
        deleteCard,
        numberChange,
    });

    function isEmptyOrSpaces(str) {
        return str === null || str.match(/^ *$/) !== null;
    }

    function numberChange(scope) {
        scope.numberValid = !isEmptyOrSpaces(scope.cardNumber);
    }

    function addCardToPassenger(cardType, cardNumber, passenger, scope) {
        if (scope) {

            if (!scope.$parent.cardType.IsNumberRequired) {
                scope.$parent.numberValid = true;
            }
            scope.$parent.formSubmitted = true;
            if (scope && scope.$parent.cardType.IsNumberRequired && !scope.$parent.numberValid) {
                return;
            }
        }

        passenger.cards.push({
            number: cardNumber,
            type: cardType,
        });

        $uibModalStack.dismissAll();
    }

    function saveCard(cardType, cardNumber, passenger, scope) {
        if (!scope.$parent.cardType.IsNumberRequired) {
            scope.$parent.numberValid = true;
        }
        scope.$parent.formSubmitted = true;
        if (!scope.$parent.numberValid) {
            return;
        }

        const existingCard = _.find(passenger.cards, (card) => card.type.Code === cardType.Code);
        existingCard.number = cardNumber;

        $uibModalStack.dismissAll();
    }

    function deleteCard(cardType, passenger) {
        _.remove(passenger.cards, (card) => card.type.Code === cardType.Code);

        $uibModalStack.dismissAll();
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/eurail-cards/eurail-cards-service.js